{
  "generatedAt": "2026-07-03",
  "title": "Prelaunch live drop",
  "decision": "Selected first merchandising drop for product pages and lead capture; checkout remains disabled.",
  "checkoutEnabled": false,
  "count": 26,
  "products": [
    {
      "sku": "PPB-SET-0001",
      "slug": "ppb-set-0001-propickleball-curated-startset-2-spelers-indoor-budget",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "not_started",
      "supplierPathDocumented": false,
      "supplierName": "Private label OEM later",
      "supplierPriority": "C",
      "launchGate": "written supplier approval required before checkout",
      "category": "startersets",
      "supplierRouteId": "private-label-later",
      "brand": "ProPickleball curated",
      "name": "Startset 2 spelers indoor budget",
      "audience": "beginners thuis/sporthal",
      "level": "starter",
      "priority": "A",
      "commercialMode": "lead_capture",
      "targetPriceBand": "EUR 49-79",
      "marginRisk": "medium",
      "rationale": "Laagdrempelig instapproduct voor zoekvraag pickleball set kopen.",
      "blockers": [
        "sample quality",
        "GPSR file",
        "supplier MOQ"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-nl-marketplace",
          "competitor": "Decathlon Nederland marketplace",
          "evidenceUrl": "https://www.decathlon.nl/sporten/pickleball",
          "benchmarkProduct": "OLIVER / marketplace 2-player starter set",
          "competitorPriceInclVat": 69.95,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 68.95,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000002364",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 1,
      "pdpPath": "/producten/ppb-set-0001-propickleball-curated-startset-2-spelers-indoor-budget/",
      "dropRole": "Instapstarter",
      "pagePitch": "Voor spelers die zonder uitzoekwerk willen starten met een complete, gecontroleerde set."
    },
    {
      "sku": "PPB-SET-0002",
      "slug": "ppb-set-0002-propickleball-curated-startset-2-spelers-outdoor-budget",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "not_started",
      "supplierPathDocumented": false,
      "supplierName": "Private label OEM later",
      "supplierPriority": "C",
      "launchGate": "written supplier approval required before checkout",
      "category": "startersets",
      "supplierRouteId": "private-label-later",
      "brand": "ProPickleball curated",
      "name": "Startset 2 spelers outdoor budget",
      "audience": "beginners buiten",
      "level": "starter",
      "priority": "A",
      "commercialMode": "lead_capture",
      "targetPriceBand": "EUR 49-79",
      "marginRisk": "medium",
      "rationale": "Outdoorballen en simpele paddles voor eerste aankoop.",
      "blockers": [
        "sample quality",
        "ball type clarity",
        "supplier MOQ"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-nl-marketplace",
          "competitor": "Decathlon Nederland marketplace",
          "evidenceUrl": "https://www.decathlon.nl/sporten/pickleball",
          "benchmarkProduct": "Marketplace 2-paddle set with net",
          "competitorPriceInclVat": 74.95,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 73.95,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000002371",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 2,
      "pdpPath": "/producten/ppb-set-0002-propickleball-curated-startset-2-spelers-outdoor-budget/",
      "dropRole": "Instapstarter",
      "pagePitch": "Voor spelers die zonder uitzoekwerk willen starten met een complete, gecontroleerde set."
    },
    {
      "sku": "PPB-SET-0003",
      "slug": "ppb-set-0003-propickleball-curated-startset-4-spelers-indoor-school",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "not_started",
      "supplierPathDocumented": false,
      "supplierName": "Private label OEM later",
      "supplierPriority": "C",
      "launchGate": "written supplier approval required before checkout",
      "category": "startersets",
      "supplierRouteId": "private-label-later",
      "brand": "ProPickleball curated",
      "name": "Startset 4 spelers indoor school",
      "audience": "scholen en sporthallen",
      "level": "starter",
      "priority": "A",
      "commercialMode": "lead_capture",
      "targetPriceBand": "EUR 99-159",
      "marginRisk": "medium",
      "rationale": "Scholen hebben meerdere paddles tegelijk nodig.",
      "blockers": [
        "school durability test",
        "supplier MOQ"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-nl-marketplace",
          "competitor": "Decathlon Nederland marketplace",
          "evidenceUrl": "https://www.decathlon.nl/sporten/pickleball",
          "benchmarkProduct": "SKINUP 4-racket starter set",
          "competitorPriceInclVat": 159,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 158,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000002388",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 3,
      "pdpPath": "/producten/ppb-set-0003-propickleball-curated-startset-4-spelers-indoor-school/",
      "dropRole": "School/gezinsstarter",
      "pagePitch": "Voor spelers die zonder uitzoekwerk willen starten met een complete, gecontroleerde set."
    },
    {
      "sku": "PPB-SET-0004",
      "slug": "ppb-set-0004-propickleball-curated-startset-4-spelers-outdoor-recreatie",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "not_started",
      "supplierPathDocumented": false,
      "supplierName": "Private label OEM later",
      "supplierPriority": "C",
      "launchGate": "written supplier approval required before checkout",
      "category": "startersets",
      "supplierRouteId": "private-label-later",
      "brand": "ProPickleball curated",
      "name": "Startset 4 spelers outdoor recreatie",
      "audience": "gezinnen en recreatieparken",
      "level": "starter",
      "priority": "A",
      "commercialMode": "lead_capture",
      "targetPriceBand": "EUR 109-169",
      "marginRisk": "medium",
      "rationale": "Gezinnen en vakantieparken starten met complete sets.",
      "blockers": [
        "weather claims",
        "shipping class"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-nl-marketplace",
          "competitor": "Decathlon Nederland marketplace",
          "evidenceUrl": "https://www.decathlon.nl/sporten/pickleball",
          "benchmarkProduct": "SKINUP 4-racket starter set",
          "competitorPriceInclVat": 159,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 158,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000002395",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 4,
      "pdpPath": "/producten/ppb-set-0004-propickleball-curated-startset-4-spelers-outdoor-recreatie/",
      "dropRole": "School/gezinsstarter",
      "pagePitch": "Voor spelers die zonder uitzoekwerk willen starten met een complete, gecontroleerde set."
    },
    {
      "sku": "PPB-SET-0013",
      "slug": "ppb-set-0013-joola-blue-lightning-pack-2-paddle-set",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "JOOLA Europe / JOOLA NL-BE",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "startersets",
      "supplierRouteId": "joola-europe",
      "brand": "JOOLA",
      "name": "Blue Lightning Pack 2 paddle set",
      "audience": "beginners met merkvoorkeur",
      "level": "starter",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 75-140",
      "marginRisk": "medium",
      "rationale": "JOOLA setlijnen zijn zichtbaar in NL/BE en EU shops.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "pickleball-eurosphere",
          "competitor": "Pickleball Eurosphere",
          "evidenceUrl": "https://pickleballeurosphere.com/en/",
          "benchmarkProduct": "JOOLA Ben Johns Blue Lightning Pack",
          "competitorPriceInclVat": 62.54,
          "matchType": "brand_family"
        },
        "targetPriceInclVat": 61.54,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000002487",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 5,
      "pdpPath": "/producten/ppb-set-0013-joola-blue-lightning-pack-2-paddle-set/",
      "dropRole": "Instapstarter",
      "pagePitch": "Voor spelers die zonder uitzoekwerk willen starten met een complete, gecontroleerde set."
    },
    {
      "sku": "PPB-SET-0017",
      "slug": "ppb-set-0017-head-flash-pack-2-paddle-starter",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "HEAD Europe / Benelux sportdistributie",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "startersets",
      "supplierRouteId": "head-europe",
      "brand": "HEAD",
      "name": "Flash Pack 2 paddle starter",
      "audience": "beginners",
      "level": "starter",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 79-120",
      "marginRisk": "medium",
      "rationale": "HEAD packs zijn zichtbaar in EU pickleball retail.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "pickleball-eurosphere",
          "competitor": "Pickleball Eurosphere",
          "evidenceUrl": "https://pickleballeurosphere.com/en/",
          "benchmarkProduct": "HEAD Flash Pack",
          "competitorPriceInclVat": 82.5,
          "matchType": "brand_family"
        },
        "targetPriceInclVat": 81.5,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000002524",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 6,
      "pdpPath": "/producten/ppb-set-0017-head-flash-pack-2-paddle-starter/",
      "dropRole": "Instapstarter",
      "pagePitch": "Voor spelers die zonder uitzoekwerk willen starten met een complete, gecontroleerde set."
    },
    {
      "sku": "PPB-PAD-0026",
      "slug": "ppb-pad-0026-joola-essentials-14mm-control",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "JOOLA Europe / JOOLA NL-BE",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "paddles",
      "supplierRouteId": "joola-europe",
      "brand": "JOOLA",
      "name": "Essentials 14mm control",
      "audience": "recreanten/intermediate",
      "level": "intermediate",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 60-240",
      "marginRisk": "medium",
      "rationale": "JOOLA heeft breed NL/BE zichtbaar assortiment.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "joola-nl-be",
          "competitor": "JOOLA Nederland en Belgie",
          "evidenceUrl": "https://joola.nl/collections/pickleball",
          "benchmarkProduct": "JOOLA Agassi Champion / entry composite family",
          "competitorPriceInclVat": 64.95,
          "matchType": "brand_family"
        },
        "targetPriceInclVat": 63.95,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000001206",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 7,
      "pdpPath": "/producten/ppb-pad-0026-joola-essentials-14mm-control/",
      "dropRole": "Keuzehulp paddle",
      "pagePitch": "Een keuzehulp-paddle voor spelers die van budget naar gerichte controle of power willen groeien."
    },
    {
      "sku": "PPB-PAD-0029",
      "slug": "ppb-pad-0029-joola-agassi-champion-14mm-control",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "JOOLA Europe / JOOLA NL-BE",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "paddles",
      "supplierRouteId": "joola-europe",
      "brand": "JOOLA",
      "name": "Agassi Champion 14mm control",
      "audience": "recreanten/intermediate",
      "level": "intermediate",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 60-240",
      "marginRisk": "medium",
      "rationale": "JOOLA heeft breed NL/BE zichtbaar assortiment.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "joola-nl-be",
          "competitor": "JOOLA Nederland en Belgie",
          "evidenceUrl": "https://joola.nl/collections/pickleball",
          "benchmarkProduct": "JOOLA Agassi Champion / entry composite family",
          "competitorPriceInclVat": 64.95,
          "matchType": "brand_family"
        },
        "targetPriceInclVat": 63.95,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000001237",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 8,
      "pdpPath": "/producten/ppb-pad-0029-joola-agassi-champion-14mm-control/",
      "dropRole": "Keuzehulp paddle",
      "pagePitch": "Een keuzehulp-paddle voor spelers die van budget naar gerichte controle of power willen groeien."
    },
    {
      "sku": "PPB-PAD-0059",
      "slug": "ppb-pad-0059-head-flash-standard",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "HEAD Europe / Benelux sportdistributie",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "paddles",
      "supplierRouteId": "head-europe",
      "brand": "HEAD",
      "name": "Flash standard",
      "audience": "beginners/recreanten",
      "level": "starter",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 55-120",
      "marginRisk": "medium",
      "rationale": "HEAD biedt toegankelijke paddle-lijnen en sterke racketsportherkenning.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-nl-marketplace",
          "competitor": "Decathlon Nederland marketplace",
          "evidenceUrl": "https://www.decathlon.nl/sporten/pickleball",
          "benchmarkProduct": "HEAD Flash Team marketplace low benchmark",
          "competitorPriceInclVat": 53.96,
          "matchType": "exact_or_close"
        },
        "targetPriceInclVat": 52.96,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000001534",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "low_to_medium"
      },
      "liveDrop": true,
      "liveDropRank": 9,
      "pdpPath": "/producten/ppb-pad-0059-head-flash-standard/",
      "dropRole": "Keuzehulp paddle",
      "pagePitch": "Een keuzehulp-paddle voor spelers die van budget naar gerichte controle of power willen groeien."
    },
    {
      "sku": "PPB-PAD-0061",
      "slug": "ppb-pad-0061-head-attitude-core-standard",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "HEAD Europe / Benelux sportdistributie",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "paddles",
      "supplierRouteId": "head-europe",
      "brand": "HEAD",
      "name": "Attitude CORE standard",
      "audience": "beginners/recreanten",
      "level": "starter",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 55-120",
      "marginRisk": "medium",
      "rationale": "HEAD biedt toegankelijke paddle-lijnen en sterke racketsportherkenning.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-nl-marketplace",
          "competitor": "Decathlon Nederland marketplace",
          "evidenceUrl": "https://www.decathlon.nl/sporten/pickleball",
          "benchmarkProduct": "HEAD Attitude SUPRM marketplace low benchmark",
          "competitorPriceInclVat": 52.46,
          "matchType": "exact_or_close"
        },
        "targetPriceInclVat": 51.46,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000001558",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "low_to_medium"
      },
      "liveDrop": true,
      "liveDropRank": 10,
      "pdpPath": "/producten/ppb-pad-0061-head-attitude-core-standard/",
      "dropRole": "Keuzehulp paddle",
      "pagePitch": "Een keuzehulp-paddle voor spelers die van budget naar gerichte controle of power willen groeien."
    },
    {
      "sku": "PPB-BAL-0142",
      "slug": "ppb-bal-0142-franklin-sports-x-40-outdoor-3-pack",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "Franklin Sports / EU-distributeur",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "ballen",
      "supplierRouteId": "franklin-eu",
      "brand": "Franklin Sports",
      "name": "X-40 Outdoor 3-pack",
      "audience": "beginners",
      "level": "recreatief",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 9-14",
      "marginRisk": "medium",
      "rationale": "Ballen zijn herhaalaankoop en kern add-on.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-nl-marketplace",
          "competitor": "Decathlon Nederland marketplace",
          "evidenceUrl": "https://www.decathlon.nl/sporten/pickleball",
          "benchmarkProduct": "Franklin X-40 3-pack",
          "competitorPriceInclVat": 12.99,
          "matchType": "exact_or_close"
        },
        "targetPriceInclVat": 11.99,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000438",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "low_to_medium"
      },
      "liveDrop": true,
      "liveDropRank": 11,
      "pdpPath": "/producten/ppb-bal-0142-franklin-sports-x-40-outdoor-3-pack/",
      "dropRole": "Verbruiksartikel",
      "pagePitch": "Een herhaalaankoop met duidelijke indoor/outdoor uitleg en lage drempel voor clubs."
    },
    {
      "sku": "PPB-BAL-0143",
      "slug": "ppb-bal-0143-franklin-sports-x-40-outdoor-12-pack",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "Franklin Sports / EU-distributeur",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "ballen",
      "supplierRouteId": "franklin-eu",
      "brand": "Franklin Sports",
      "name": "X-40 Outdoor 12-pack",
      "audience": "recreanten/clubs",
      "level": "club",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 25-35",
      "marginRisk": "medium",
      "rationale": "Club en school verbruik.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-nl-marketplace",
          "competitor": "Decathlon Nederland marketplace",
          "evidenceUrl": "https://www.decathlon.nl/sporten/pickleball",
          "benchmarkProduct": "Franklin X-40 3-pack prorated to 12-pack",
          "competitorPriceInclVat": 51.96,
          "matchType": "category_proxy_prorated"
        },
        "targetPriceInclVat": 50.96,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000445",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 12,
      "pdpPath": "/producten/ppb-bal-0143-franklin-sports-x-40-outdoor-12-pack/",
      "dropRole": "Verbruiksartikel",
      "pagePitch": "Een herhaalaankoop met duidelijke indoor/outdoor uitleg en lage drempel voor clubs."
    },
    {
      "sku": "PPB-BAL-0145",
      "slug": "ppb-bal-0145-franklin-sports-x-26-indoor-3-pack",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "Franklin Sports / EU-distributeur",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "ballen",
      "supplierRouteId": "franklin-eu",
      "brand": "Franklin Sports",
      "name": "X-26 Indoor 3-pack",
      "audience": "beginners",
      "level": "recreatief",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 9-14",
      "marginRisk": "medium",
      "rationale": "Ballen zijn herhaalaankoop en kern add-on.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "pickleball-eurosphere",
          "competitor": "Pickleball Eurosphere",
          "evidenceUrl": "https://pickleballeurosphere.com/en/",
          "benchmarkProduct": "Franklin X-26 Indoor",
          "competitorPriceInclVat": 18.33,
          "matchType": "brand_family"
        },
        "targetPriceInclVat": 17.33,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000469",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 13,
      "pdpPath": "/producten/ppb-bal-0145-franklin-sports-x-26-indoor-3-pack/",
      "dropRole": "Verbruiksartikel",
      "pagePitch": "Een herhaalaankoop met duidelijke indoor/outdoor uitleg en lage drempel voor clubs."
    },
    {
      "sku": "PPB-BAL-0148",
      "slug": "ppb-bal-0148-joola-primo-3-pack",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "JOOLA Europe / JOOLA NL-BE",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "ballen",
      "supplierRouteId": "joola-europe",
      "brand": "JOOLA",
      "name": "Primo 3-pack",
      "audience": "recreanten",
      "level": "recreatief",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 10-20",
      "marginRisk": "medium",
      "rationale": "JOOLA ballen versterken merkroute.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "joola-nl-be",
          "competitor": "JOOLA Nederland en Belgie",
          "evidenceUrl": "https://joola.nl/collections/pickleball",
          "benchmarkProduct": "JOOLA Pickleball Bal Primo",
          "competitorPriceInclVat": 10.95,
          "matchType": "exact_or_close"
        },
        "targetPriceInclVat": 9.95,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000490",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "low_to_medium"
      },
      "liveDrop": true,
      "liveDropRank": 14,
      "pdpPath": "/producten/ppb-bal-0148-joola-primo-3-pack/",
      "dropRole": "Verbruiksartikel",
      "pagePitch": "Een herhaalaankoop met duidelijke indoor/outdoor uitleg en lage drempel voor clubs."
    },
    {
      "sku": "PPB-BAL-0150",
      "slug": "ppb-bal-0150-joola-hc-40-3-pack",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "JOOLA Europe / JOOLA NL-BE",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "ballen",
      "supplierRouteId": "joola-europe",
      "brand": "JOOLA",
      "name": "HC-40 3-pack",
      "audience": "recreanten",
      "level": "recreatief",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 10-20",
      "marginRisk": "medium",
      "rationale": "JOOLA ballen versterken merkroute.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "joola-nl-be",
          "competitor": "JOOLA Nederland en Belgie",
          "evidenceUrl": "https://joola.nl/collections/pickleball",
          "benchmarkProduct": "JOOLA HC-40 pickleball",
          "competitorPriceInclVat": 10.95,
          "matchType": "exact_or_close"
        },
        "targetPriceInclVat": 9.95,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000513",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "low_to_medium"
      },
      "liveDrop": true,
      "liveDropRank": 15,
      "pdpPath": "/producten/ppb-bal-0150-joola-hc-40-3-pack/",
      "dropRole": "Verbruiksartikel",
      "pagePitch": "Een herhaalaankoop met duidelijke indoor/outdoor uitleg en lage drempel voor clubs."
    },
    {
      "sku": "PPB-BAL-0154",
      "slug": "ppb-bal-0154-head-penn-pro-40-outdoor-3-pack",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "HEAD Europe / Benelux sportdistributie",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "ballen",
      "supplierRouteId": "head-europe",
      "brand": "HEAD/Penn",
      "name": "Pro 40 Outdoor 3-pack",
      "audience": "beginners/recreanten",
      "level": "recreatief",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 9-18",
      "marginRisk": "medium",
      "rationale": "HEAD/Penn past bij sportclub vertrouwen.",
      "blockers": [
        "dealer authorization",
        "content rights",
        "warranty route"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "pickleball-eurosphere",
          "competitor": "Pickleball Eurosphere",
          "evidenceUrl": "https://pickleballeurosphere.com/en/",
          "benchmarkProduct": "HEAD Pro 40 Outdoor",
          "competitorPriceInclVat": 18.33,
          "matchType": "exact_or_close"
        },
        "targetPriceInclVat": 17.33,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000551",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "low_to_medium"
      },
      "liveDrop": true,
      "liveDropRank": 16,
      "pdpPath": "/producten/ppb-bal-0154-head-penn-pro-40-outdoor-3-pack/",
      "dropRole": "Verbruiksartikel",
      "pagePitch": "Een herhaalaankoop met duidelijke indoor/outdoor uitleg en lage drempel voor clubs."
    },
    {
      "sku": "PPB-NET-0172",
      "slug": "ppb-net-0172-propickleball-curated-portable-net-standard",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "EU sportinrichting groothandel",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "netten-en-belijning",
      "supplierRouteId": "eu-sportinrichting",
      "brand": "ProPickleball curated",
      "name": "Portable Net standard",
      "audience": "thuis/scholen/clubs",
      "level": "club",
      "priority": "A",
      "commercialMode": "quote_request",
      "targetPriceBand": "EUR 25-180",
      "marginRisk": "medium",
      "rationale": "Nets en belijning zijn kern voor clubs/scholen.",
      "blockers": [
        "sample stability test",
        "bulky shipping proof",
        "GPSR file"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-de-marketplace",
          "competitor": "Decathlon Duitsland marketplace",
          "evidenceUrl": "https://www.decathlon.de/alle-sportarten-a-z/pickleball",
          "benchmarkProduct": "Portable pickleball net marketplace benchmark",
          "competitorPriceInclVat": 94.99,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 93.99,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000933",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 17,
      "pdpPath": "/producten/ppb-net-0172-propickleball-curated-portable-net-standard/",
      "dropRole": "Veldopbouw",
      "pagePitch": "Voor scholen, clubs en recreatieparken die snel een speelveld willen opzetten."
    },
    {
      "sku": "PPB-NET-0181",
      "slug": "ppb-net-0181-propickleball-curated-court-line-kit-standard",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "EU sportinrichting groothandel",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "netten-en-belijning",
      "supplierRouteId": "eu-sportinrichting",
      "brand": "ProPickleball curated",
      "name": "Court Line Kit standard",
      "audience": "thuis/scholen/clubs",
      "level": "club",
      "priority": "A",
      "commercialMode": "quote_request",
      "targetPriceBand": "EUR 25-180",
      "marginRisk": "medium",
      "rationale": "Nets en belijning zijn kern voor clubs/scholen.",
      "blockers": [
        "sample stability test",
        "bulky shipping proof",
        "GPSR file"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-be-marketplace",
          "competitor": "Decathlon Belgie marketplace",
          "evidenceUrl": "https://www.decathlon.be/nl/brands/pickleball-x",
          "benchmarkProduct": "Franklin court marking set marketplace benchmark",
          "competitorPriceInclVat": 38.5,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 37.5,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000001022",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 18,
      "pdpPath": "/producten/ppb-net-0181-propickleball-curated-court-line-kit-standard/",
      "dropRole": "Veldopbouw",
      "pagePitch": "Voor scholen, clubs en recreatieparken die snel een speelveld willen opzetten."
    },
    {
      "sku": "PPB-NET-0187",
      "slug": "ppb-net-0187-propickleball-curated-court-marker-set-standard",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "EU sportinrichting groothandel",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "netten-en-belijning",
      "supplierRouteId": "eu-sportinrichting",
      "brand": "ProPickleball curated",
      "name": "Court Marker Set standard",
      "audience": "thuis/scholen/clubs",
      "level": "club",
      "priority": "A",
      "commercialMode": "quote_request",
      "targetPriceBand": "EUR 25-180",
      "marginRisk": "medium",
      "rationale": "Nets en belijning zijn kern voor clubs/scholen.",
      "blockers": [
        "sample stability test",
        "bulky shipping proof",
        "GPSR file"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-be-marketplace",
          "competitor": "Decathlon Belgie marketplace",
          "evidenceUrl": "https://www.decathlon.be/nl/brands/pickleball-x",
          "benchmarkProduct": "Franklin court marking set marketplace benchmark",
          "competitorPriceInclVat": 38.5,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 37.5,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000001084",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 19,
      "pdpPath": "/producten/ppb-net-0187-propickleball-curated-court-marker-set-standard/",
      "dropRole": "Veldopbouw",
      "pagePitch": "Voor scholen, clubs en recreatieparken die snel een speelveld willen opzetten."
    },
    {
      "sku": "PPB-ACC-0197",
      "slug": "ppb-acc-0197-propickleball-curated-overgrip-3-pack",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "EU racketsport accessoires distributeur",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "grips-accessoires",
      "supplierRouteId": "racketsport-accessories",
      "brand": "ProPickleball curated",
      "name": "Overgrip 3-pack",
      "audience": "clubs/recreanten",
      "level": "club",
      "priority": "A",
      "commercialMode": "lead_capture",
      "targetPriceBand": "EUR 8-25",
      "marginRisk": "low",
      "rationale": "Herhaalaankoop en bundelbaar.",
      "blockers": [
        "material claims",
        "packaging proof"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "joola-nl-be",
          "competitor": "JOOLA Nederland en Belgie",
          "evidenceUrl": "https://joola.nl/collections/pickleball",
          "benchmarkProduct": "JOOLA Grip Tape White Ridge 2-pack",
          "competitorPriceInclVat": 15.95,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 14.95,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000025",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 20,
      "pdpPath": "/producten/ppb-acc-0197-propickleball-curated-overgrip-3-pack/",
      "dropRole": "Marge add-on",
      "pagePitch": "Een praktische add-on die comfort en grip refresh ondersteunt zonder grote retourdruk."
    },
    {
      "sku": "PPB-ACC-0202",
      "slug": "ppb-acc-0202-propickleball-curated-paddle-eraser-single",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "EU racketsport accessoires distributeur",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "grips-accessoires",
      "supplierRouteId": "racketsport-accessories",
      "brand": "ProPickleball curated",
      "name": "Paddle Eraser single",
      "audience": "recreanten",
      "level": "recreatief",
      "priority": "A",
      "commercialMode": "lead_capture",
      "targetPriceBand": "EUR 3-15",
      "marginRisk": "low",
      "rationale": "Lage retourkans en add-on marge.",
      "blockers": [
        "material claims",
        "supplier MOQ"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "decathlon-de-marketplace",
          "competitor": "Decathlon Duitsland marketplace",
          "evidenceUrl": "https://www.decathlon.de/alle-sportarten-a-z/pickleball",
          "benchmarkProduct": "Racket sport overgrip promotion / small accessory floor",
          "competitorPriceInclVat": 3.99,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 2.99,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000070",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 21,
      "pdpPath": "/producten/ppb-acc-0202-propickleball-curated-paddle-eraser-single/",
      "dropRole": "Marge add-on",
      "pagePitch": "Een praktische add-on die comfort en grip refresh ondersteunt zonder grote retourdruk."
    },
    {
      "sku": "PPB-ACC-0206",
      "slug": "ppb-acc-0206-propickleball-curated-edge-guard-tape-single",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "EU racketsport accessoires distributeur",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "grips-accessoires",
      "supplierRouteId": "racketsport-accessories",
      "brand": "ProPickleball curated",
      "name": "Edge Guard Tape single",
      "audience": "recreanten",
      "level": "recreatief",
      "priority": "A",
      "commercialMode": "lead_capture",
      "targetPriceBand": "EUR 3-15",
      "marginRisk": "low",
      "rationale": "Lage retourkans en add-on marge.",
      "blockers": [
        "material claims",
        "supplier MOQ"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "joola-nl-be",
          "competitor": "JOOLA Nederland en Belgie",
          "evidenceUrl": "https://joola.nl/collections/pickleball",
          "benchmarkProduct": "JOOLA Neoprene paddle cover",
          "competitorPriceInclVat": 19.95,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 18.95,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000117",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 22,
      "pdpPath": "/producten/ppb-acc-0206-propickleball-curated-edge-guard-tape-single/",
      "dropRole": "Marge add-on",
      "pagePitch": "Een praktische add-on die comfort en grip refresh ondersteunt zonder grote retourdruk."
    },
    {
      "sku": "PPB-BAG-0220",
      "slug": "ppb-bag-0220-propickleball-curated-paddle-sling-bag-standard",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "EU racketsport accessoires distributeur",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "tassen-accessoires",
      "supplierRouteId": "racketsport-accessories",
      "brand": "ProPickleball curated",
      "name": "Paddle Sling Bag standard",
      "audience": "recreanten",
      "level": "recreatief",
      "priority": "A",
      "commercialMode": "lead_capture",
      "targetPriceBand": "EUR 15-60",
      "marginRisk": "medium",
      "rationale": "Bundelbaar met paddles en startersets.",
      "blockers": [
        "dimensions",
        "material proof"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "head-official-eu",
          "competitor": "HEAD official EU shop",
          "evidenceUrl": "https://www.head.com/en_IE/shop-pickleball",
          "benchmarkProduct": "HEAD Tour Crossbody Bag",
          "competitorPriceInclVat": 30,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 29,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000254",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 23,
      "pdpPath": "/producten/ppb-bag-0220-propickleball-curated-paddle-sling-bag-standard/",
      "dropRole": "Bundel add-on",
      "pagePitch": "Bundelproduct voor spelers die paddles, ballen en accessoires netjes willen meenemen."
    },
    {
      "sku": "PPB-BAG-0224",
      "slug": "ppb-bag-0224-propickleball-curated-backpack-standard",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "EU racketsport accessoires distributeur",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "tassen-accessoires",
      "supplierRouteId": "racketsport-accessories",
      "brand": "ProPickleball curated",
      "name": "Backpack standard",
      "audience": "recreanten",
      "level": "recreatief",
      "priority": "A",
      "commercialMode": "lead_capture",
      "targetPriceBand": "EUR 15-60",
      "marginRisk": "medium",
      "rationale": "Bundelbaar met paddles en startersets.",
      "blockers": [
        "dimensions",
        "material proof"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "head-official-eu",
          "competitor": "HEAD official EU shop",
          "evidenceUrl": "https://www.head.com/en_IE/shop-pickleball",
          "benchmarkProduct": "HEAD Tour Pickleball Backpack 22L",
          "competitorPriceInclVat": 60,
          "matchType": "category_proxy"
        },
        "targetPriceInclVat": 59,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000292",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 24,
      "pdpPath": "/producten/ppb-bag-0224-propickleball-curated-backpack-standard/",
      "dropRole": "Bundel add-on",
      "pagePitch": "Bundelproduct voor spelers die paddles, ballen en accessoires netjes willen meenemen."
    },
    {
      "sku": "PPB-SHO-0258",
      "slug": "ppb-sho-0258-onix-owl-eyewear-clear-lens",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "ONIX / Escalade Sports dealerroute",
      "supplierPriority": "B",
      "launchGate": "written supplier approval required before checkout",
      "category": "schoenen-en-bescherming",
      "supplierRouteId": "onix-escalade",
      "brand": "ONIX",
      "name": "Owl Eyewear clear lens",
      "audience": "jeugd/beginners/dubbelspel",
      "level": "recreatief",
      "priority": "A",
      "commercialMode": "supplier_verification",
      "targetPriceBand": "EUR 20-45",
      "marginRisk": "medium",
      "rationale": "Veiligheid differentieert de shop.",
      "blockers": [
        "impact norm proof",
        "dealer approval"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "onix-official-us",
          "competitor": "ONIX Pickleball official US",
          "evidenceUrl": "https://www.onixpickleball.com/collections/protective-eyewear",
          "benchmarkProduct": "ONIX Owl protective eyewear",
          "competitorPriceInclVat": 30.56,
          "matchType": "exact_or_close"
        },
        "targetPriceInclVat": 29.56,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000002586",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "low_to_medium"
      },
      "liveDrop": true,
      "liveDropRank": 25,
      "pdpPath": "/producten/ppb-sho-0258-onix-owl-eyewear-clear-lens/",
      "dropRole": "Veiligheid/affiliate",
      "pagePitch": "Veiligheidsgerichte keuzehulp; eigen voorraad pas na norm- en retourproof."
    },
    {
      "sku": "PPB-CLB-0284",
      "slug": "ppb-clb-0284-propickleball-curated-clubpack-8-spelers-indoor",
      "checkoutEnabled": false,
      "stockPolicy": "not_stocked_prelaunch",
      "authorizationStatus": "contact_required",
      "supplierPathDocumented": false,
      "supplierName": "EU sportinrichting groothandel",
      "supplierPriority": "A",
      "launchGate": "written supplier approval required before checkout",
      "category": "clubpakketten",
      "supplierRouteId": "eu-sportinrichting",
      "brand": "ProPickleball curated",
      "name": "Clubpack 8 spelers indoor",
      "audience": "scholen en sportclubs",
      "level": "club",
      "priority": "A",
      "commercialMode": "quote_request",
      "targetPriceBand": "EUR 360-680",
      "marginRisk": "medium",
      "rationale": "Offertepakket combineert paddles, ballen, netten, belijning en training aids.",
      "blockers": [
        "supplier quotes",
        "bulky shipping",
        "per-item GPSR files",
        "delivery lead time"
      ],
      "marketResearch": {
        "checkedAt": "2026-07-03",
        "pricingRule": "target_price_is_competitor_benchmark_minus_1_eur",
        "pricingPublishStatus": "internal_benchmark_not_public_offer",
        "benchmark": {
          "sourceId": "pickleball-eurosphere",
          "competitor": "Pickleball Eurosphere",
          "evidenceUrl": "https://pickleballeurosphere.com/en/",
          "benchmarkProduct": "Club package benchmark scaled to 8 players",
          "competitorPriceInclVat": 319.6,
          "matchType": "category_proxy_prorated"
        },
        "targetPriceInclVat": 318.6,
        "targetVsCompetitorDelta": -1,
        "sampleEan13": "2900000000735",
        "sampleEanStatus": "internal_sample_not_for_feed",
        "eanPublicationGate": "replace with supplier/GS1 verified GTIN before feed, PDP schema or marketplace export",
        "uncertainty": "medium_to_high"
      },
      "liveDrop": true,
      "liveDropRank": 26,
      "pdpPath": "/producten/ppb-clb-0284-propickleball-curated-clubpack-8-spelers-indoor/",
      "dropRole": "B2B quote hero",
      "pagePitch": "Offertepakket voor clinics, scholen en verenigingen met quote-first logistiek."
    }
  ]
}
